import CategoryScoreCardsLegacy from "./CategoryScoreCardsLegacy";
import CategoryScoreCardsNew    from "./CategoryScoreCardsNew";

// ─── Feature Flag ─────────────────────────────────────────────────────────────
// false → old UI: 3 cards (RBI total, Rank, Sentiment)
// true  → new UI: RBI stacked bar + Rank + Sentiment + Brand Pillars + Purchase Criteria
const ENABLE_NEW_RBI_UI = true;

export default function CategoryScoreCards({ category }) {
  return ENABLE_NEW_RBI_UI
    ? <CategoryScoreCardsNew    category={category} />
    : <CategoryScoreCardsLegacy category={category} />;
}
